<template>
  <v-card elevation="0">
    <v-card-title>
      <v-icon left color="orange darken-4">mdi-account-multiple</v-icon>Compte
    </v-card-title>
    <v-card-text class="headline font-weight-bold">
      <template v-if="loading==false">{{accountCount}}</template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    accountCount: 0,
    loading: false
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.accounts()
        .then(data => {
          this.accountCount = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions("statistique", ["accounts"])
  }
};
</script>

<style>
</style>